import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://da2abbb23d71df7ff81e7abfe00b5d1e@o4508701300686848.ingest.us.sentry.io/4508710558564352",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0,
  integrations: [Sentry.browserTracingIntegration()],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});